document.addEventListener('DOMContentLoaded', function () {
    navHandle();
    InitSlideshow();
    InitPlayVideo();
    showMore();
    accordion();
    select();
    booking();
    search();
    searchBookingPhysical();
    searchBookingOnline();
});
